import moment from "moment/moment";
import { DATETIME_TYPES, monthMapper, PAGES_NAMES, ParentHospitalConfigurations, ROLES } from "./common/constants";
import fileDownload from "js-file-download";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import i18n from './i18n'
import { validationPatterns } from "./component/FieldInput/fieldInput.validation";
import { HospitalConfigKeys, Lookup, Original } from "./common/Common.Type";
import { hospitalConigurationType } from "./types/ContextsType/Privileges.Type";
import { HTMLAttributes } from "react";
import { PlacesType } from "react-tooltip";
import html2canvas from "html2canvas";

export const ToBase64 = (file: File) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = error => reject(error);
});

export const validateUploadedFile = (fileInput: any, allowedExtensions: any[]) => {
  return fileInput && allowedExtensions.some((ext: string) => fileInput.name.toLowerCase().endsWith(ext));
};


export const getFromLocal = (name: string) => localStorage.getItem(name) || null || ""
export const setToLocal = (name: string, value: string) => localStorage.setItem(name, value)


export const ValidatePhone = (mobile: string) => {
  return /^01[0125][0-9]{8}$/g.test(mobile)
}

export const validatePasswordCraiteria = (password: string) => {
  let passordValidatedParts = {
    passLength: password?.length >= 10,
    //@ts-ignore
    smallChars: password && [...password]?.some(char => /[a-z]/.test(char)),
    //@ts-ignore
    capsChars: password && [...password]?.some(char => /[A-Z]/.test(char)),
    //@ts-ignore
    SpecialChars: password && [...password]?.some(char => /[@$!%*#?=_~\;'&-]/.test(char)),
    //@ts-ignore
    numberVal: password && [...password]?.some(char => /[0-9]/.test(char)),
  }
  return passordValidatedParts

}

export const handleSearchParams = (searchData = {}, tableFiller: any | null | undefined) => {
  var searchObject = {};

  Object.entries(searchData).forEach(([key, value]) => {
    //@ts-ignore
    if (typeof value === "object" && value?.accessor) {
      //@ts-ignore

      searchObject[value.accessor] = typeof value === "string" ? value.value.trim() : value.value;
    } else {
      //@ts-ignore

      searchObject[key] = typeof value === "string" ? value.trim() : value;
    }
  });


  let searchParams = `?${"searchParams"}=${JSON.stringify(searchObject)}`;
  if (tableFiller) return appendPaginationAndSorting(searchParams, tableFiller, "Id:-1");
  return searchParams;
};



export const ArrayParams = (array: any[], key: string, currentParams: string) => {
  let params = currentParams;

  if (array.length > 0) {
    array.forEach((item: any) => {
      params += `& ${key}=${item} `;
    });
  }

  return params;
}

export const appendPaginationAndSorting = (baseURL: string, tableFiller: any, defaultSort: string) => {
  const { page, PageSize } = tableFiller;
  return `${baseURL}&page=${page}&pageLength=${PageSize}&sort=${defaultSort} `;
};

export const GetRoleId = () => {
  if (!localStorage.getItem("accessToken")) {
    return null
  } else {
    return JSON.stringify(jwt_decode(localStorage.getItem("accessToken") || "")).split("role\":")[1].split(',')[0].split('"')[1]

  }
}

export const ValidateSSN = (SSN: string) => {
  return /(2|3)[0-9][0-9](0[1-9]|1[0-2])(0[1-9]|(1|2)[0-9]|3[0-1])(01|02|03|04|05|06|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d/g.test(SSN)
}

export const ValidateEmail = (email: string) => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email)
}

export function isValidNationalID(value: string) {
  if (value.length != 14)
    return false
  var pattern = /(2|3)[0-9][0-9](0[1-9]|1[0-2])(0[1-9]|(1|2)[0-9]|3[0-1])(01|02|03|04|05|06|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d/;
  return pattern.test(value);
}

export const CheckArabicText = (text: string) =>
  /^[\u0621-\u064A0-9\s:,\\()\-_,]+$/.test(text);

export const CheckEnglishText = (text: string) =>
  /^[a-zA-Z0-9\s:,\\()-_*]*$/.test(text);

export const toolTipAtrributes = (name?: string, placement?: PlacesType, collapsed?: boolean): HTMLAttributes<HTMLElement> | undefined => {
  if (!collapsed) {
    return {
      "data-tooltip-id": "my-tooltip",
      "data-tooltip-content": name || "",
      "data-tooltip-place": placement || 'left'
    }
  }
}

export const FormateDate = (date: Date, t: Function, type = DATETIME_TYPES.FullDate) => {
  if (!date)
    return null;
  let dateTiem;
  if (type === DATETIME_TYPES.TimeOnly)
    dateTiem = moment(date).format("hh:mm A");
  else if (type === DATETIME_TYPES.DateOnly)
    dateTiem = moment(date).format('YYYY-MM-DD')
  else
    dateTiem = moment(date).format("YYYY/MM/DD  hh:mm A")

  return dateTiem.replace('AM', t('AM')).replace('PM', t('PM'));

}

export const isEmpty = (value: string) => value == null || value.trim?.() === "" || value === undefined;

//@ts-ignore
export const IsListEmpty = (List = []) => List?.includes("") || List?.includes(null) || List?.includes(undefined) || List?.some(listElement => listElement?.length == 0)

export const IsDependanciesValid = (ValidationObject: any) => {

  if (ValidationObject.isAllowAllRegion)
    return true

  if (ValidationObject?.OverIds?.includes(ValidationObject.Id))
    return true

  if (ValidationObject?.ValidationLists?.filter((List: any[]) => List?.length == 0)?.length != ValidationObject?.ValidationCount)
    return true

  return false
}

export const ConvertToListIds = (List?: any[]) => List ? List?.map((element: any) => element?.value) : []

export const GetStringOfListIds = (list: any[]) => ConvertToListIds(list).join(',')


export const downloadFile = (data: any, filename: string) => fileDownload(data, concatWithCurrentDate(filename));

export const concatWithCurrentDate = (fileName: string) => {
  var currentDateTime = moment().format("YYYY-MM-DD hh:mm A");

  const [name, extension] = fileName.split('.');

  return `${name}_${currentDateTime}.${extension} `;
};

export const handlePathes = (fileSrc: string, imgLink: string) => {
  if (imgLink)
    return `${window.API_URL}${fileSrc}/${imgLink}`
  return null
}

export const handleDate = (date?: Date | string) => date ? moment(date).format('YYYY-MM-DD') : ""

export const GetDataFromNationalId = (nationalId: string) => {
  const year = parseInt(nationalId.slice(1, 3));
  const month = parseInt(nationalId.slice(3, 5));
  const day = parseInt(nationalId.slice(5, 7));
  const century = parseInt(nationalId[0]);
  const genderCode = parseInt(nationalId.slice(9, 13));
  const gender = genderCode % 2 === 0 ? 1 : 0;
  const birthYear = century >= 3 ? year + 2000 : year + 1900;
  const birthDate = new Date(birthYear, month - 1, day);
  const today = new Date();
  const age = today.getFullYear() - birthDate.getFullYear();

  return {
    gender: gender,
    age: age,
    birthDate: birthDate
  }
}

//@ts-ignore
export const isValid = (...args) => {
  let stringsOrObjectsList = args.find(element => element?.length) || []
  let elementDependsOfValObjet = args.find(element => element?.OverIds != null) || null

  if (stringsOrObjectsList.length > 0 && IsListEmpty(stringsOrObjectsList)) {
    toast.error(i18n.t("Please fill all fields"));
    return false
  }

  if (!!elementDependsOfValObjet && !IsDependanciesValid(elementDependsOfValObjet)) {
    toast.error(i18n.t("Please fill all fields"));
    return false
  }

  return true

}

export const clickOutHandler = (ref: any, setter: Function, e: any) => {
  if (ref?.current && !ref?.current?.contains(e.target))
    setter(false)
}


export const handleExternalSearch = (dataObject: any) => {
  let searchObject = {
    type: dataObject.Type,
    isMulti: dataObject?.isMulti || true,
    Header: dataObject?.Header,
    accessor: dataObject?.probName,
    probName: dataObject?.probName

  }

  if (dataObject?.apiSource)
    //@ts-ignore
    searchObject.apiSource = dataObject?.apiSource

  if (dataObject?.options)
    //@ts-ignore
    searchObject.options = dataObject?.options

  return searchObject

}

export const isListNotValid = (listOfObject: any[]) => {
  return listOfObject?.map(element => isObjectValid(element))?.includes(false)
}

export const isObjectValid = (object: any) => Object.entries(object)?.filter((entry: any[], index: number) => [null, undefined, '']?.includes(entry[1])).length == 0


export const getStatusColor = (status: string, colorMap: any) => {
  return colorMap[status] || "gray";
};


//@ts-ignore
export const getMonthName = (monthNumber: string) => monthMapper[monthNumber] || "Invalid Month";




export function isAllowedToFetchData(
  { userRoleId, authorizedPages, controllerName, apiEndpoint }
    : { userRoleId: number | string | null, authorizedPages: any[], controllerName: string, apiEndpoint: Function }
) {

  if (userRoleId == ROLES.SUPER_ADMIN) return true;
  let pageKey: string
  if (apiEndpoint) {
    pageKey = `${apiEndpoint}`.split('/')[1];
  } else {
    pageKey = controllerName
  }
  //@ts-ignore
  const pageId = PAGES_NAMES[pageKey];

  return authorizedPages.find((screen: any) => screen.id === pageId)?.privileges?.canGet;
}

export const TableCellBehavior = ({ type = null, lookupApi = null, options = [], isMulti = false, visible = true, depArr = [] }) => {

  let searchObject: any = {
    canSearch: true
  }

  if (type) {
    searchObject['type'] = type
  }

  if (lookupApi && !options.length) {
    searchObject['sourceApi'] = lookupApi
  }

  if (options.length && !lookupApi) {
    searchObject['options'] = options
  }

  if (isMulti) {
    searchObject['isMulti'] = isMulti
  }

  if (visible) {
    searchObject['visible'] = visible
  }

  if (depArr.length) {
    searchObject['depArr'] = depArr
  }


  return searchObject

}

export const CustomColumn = ({ render, name = "actions" }: { render: Function, name: string }) => {

  return ({
    id: `${Date.now}`,
    Header: name,
    Cell: ({ row: { original } }: { row: { original: Original } }) => render(ExtractData({ row: { original } }))
  })
}

export const ExtractData = (row: any) => row.row.original


export const CheckIFNullable = (value: any) => [undefined, null].includes(value)

export const validationFieldTypes = {
  Form: 1,
  Fields: 2,
}

export const errorToaster = (Message: string) => toast.error(i18n.t(Message))
//@ts-ignore
export const successToaster = (Message: string, replaceTo?: any) => toast.success(i18n.t(Message, replaceTo))
//@ts-ignore

export const infoToaster = (Message: string, replaceTo?: any) => toast.info(i18n.t(Message, replaceTo))

export const validateFields = ({ setter, value, name = "", isRequired = false, requiredMessage = "", mode = validationFieldTypes.Fields }
  : { setter: Function, value: any, name?: string, isRequired?: boolean, requiredMessage?: string, mode?: number }
) => {
  //@ts-ignore
  const validation = validationPatterns[name];

  let normalizedValue

  if (typeof value === "string") normalizedValue = value.trim()

  if (typeof value === "object") CheckIFNullable(value) ? normalizedValue = "" : normalizedValue = value?.value

  if (Array.isArray(value) && !!value?.length) normalizedValue = value[0].value

  const requiredError = isRequired && !normalizedValue ? requiredMessage || `${name} is required` : null;

  const patternError = normalizedValue && validation && !validation.regex.test(normalizedValue) ? validation.message : null;

  const validationMessage = requiredError || patternError || null;

  if (mode === validationFieldTypes.Form) {
    setter((prev: any) => ({ ...prev, [name]: { ...prev[name], errorMsg: validationMessage }, }));
  } else {
    setter({ value, errorMsg: validationMessage, isRequired });
  }
  return !!validationMessage;
};

export const mapOption = (selected: Lookup | Lookup[] | null, isMulti?: boolean) => {
  if (!selected) return "";
  //@ts-ignore
  return isMulti ? selected.map((opt: any) => ({ label: opt.label, value: opt.value })) : { label: selected.label, value: selected.value };
}
export const buildQueryParams = (params?: Record<string, any>) =>
  params ? `?${new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([, v]) => v !== null && v !== undefined)))}` : "";



export const dateFormatter = (
  date?: string | Date | null,
  local: "ar" | "en" = "ar",
  format?: {
    day?: "2-digit" | "numeric";
    month?: "2-digit" | "numeric" | "long" | "narrow" | "short";
    year?: "2-digit" | "numeric";
    hour?: "2-digit" | "numeric";
    minute?: "2-digit" | "numeric";
  }
) => {
  const localCountry = local === "ar" ? "ar-EG" : "en-GB";
  return date
    ? new Date(date).toLocaleDateString(localCountry, {
      day: format?.day,
      month: format?.month,
      year: format?.year,
      hour: format?.hour,
      minute: format?.minute,
      hour12: true,
    })
    : "--";
};


export const getMonthNumber = (startDate?: string, endDate?: string) => {
  if (!startDate) return 0

  const start = new Date(startDate)
  const now = new Date(endDate ?? new Date().toISOString())

  return (
    (now.getFullYear() - start.getFullYear()) * 12 +
    (now.getMonth() - start.getMonth()) +
    1
  )
}


export const GetPrivileges = (authorizedPages: any[], pageNumber: number | string | null) => {

  return authorizedPages?.find((p: any) => p.id === pageNumber)?.privileges
}

export const getRemainingDays = (date?: string | Date | null) => {
  if (!date) return null;

  const today = new Date();
  const target = new Date(date);
  const diffTime = target.getTime() - today.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays || 0;
}

export const getHospitalConfiguralion = (hospitalConfigurations: hospitalConigurationType[], config: HospitalConfigKeys) => {
  return hospitalConfigurations.find(item => item.feature === ParentHospitalConfigurations[config])
}


export const takeScreenshot = async (
  element: HTMLElement | null,
  options: {
    fileName?: string
    scale?: number
  } = {}
): Promise<void> => {
  if (!element) return

  const {
    fileName = "screenshot",
    scale = 2
  } = options

  const canvas = await html2canvas(element, {
    scale: scale,
    useCORS: true,
    allowTaint: false,
    logging: false,
  })

  const image = canvas.toDataURL("image/png")

  const link = document.createElement("a")
  link.href = image
  link.download = fileName + ".png"
  link.click()
}

export async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(i18n.t("textCopiedSuccessfully"))
  } catch (err) {
    console.error("Failed to copy: ", err);
  }
}

export const handleAuthSuccess = ({ data, setIsLoggedIn }: { data: any, setIsLoggedIn: any }) => {
  setToLocal("accessToken", data?.accessToken);
  setToLocal("refreshToken", data?.refreshToken);
  setToLocal("userName", data?.userName);
  setToLocal("roleName", data?.roleName);
  setToLocal("roleId", data?.roleId);

  setIsLoggedIn(true);
};

export const checkIfSelectedPharmacy = (state: Record<string, Lookup>) => {
  if (state?.pharmName?.value) return true
}
